var bookingFrame = document.getElementById('t2g-booking');
var receiveMessage = function (event) {
if (event.origin === 'https://booking.termin2go.com') {
    if (bookingFrame && event.data.type === 'heightChanged') {
        bookingFrame.height = event.data.height + 50;
    }
    }
};
window.addEventListener('message', receiveMessage, false);
